import { IInvoiceSearchResultModel } from "us.common/reducers/MainSearch/Interfaces";

export const InvoiceSearchModel: IInvoiceSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
